import { createContext, useCallback, useContext, useState } from 'react';

interface CurrentItemIds {
  [id: string]: string;
}
interface AccordionContextInterface {
  currentItemIds: CurrentItemIds;
  appendId: (id: string) => void;
  removeId: (id: string) => void;
  isActive: (id: string) => boolean;
}

interface AccordionProviderProps {
  children: React.ReactNode;
  multi?: boolean;
}

const defaultContextValue: AccordionContextInterface = {
  currentItemIds: {},
  appendId: () => {
    throw new Error('Not Implemented');
  },
  removeId: () => {
    throw new Error('Not Implemented');
  },
  isActive: () => {
    throw new Error('Not Implemented');
  },
};

const AccodrionContext = createContext<AccordionContextInterface>(defaultContextValue);

const useAccordionContextProvider = (muli?: boolean): AccordionContextInterface => {
  const [currentItemIds, setCurrentItemId] = useState<CurrentItemIds>({});
  const appendId = useCallback(
    (id: string) => {
      setCurrentItemId((prev) => {
        if (muli) {
          return { ...prev, [id]: id };
        } else {
          return { [id]: id };
        }
      });
    },
    [muli]
  );
  const removeId = useCallback((id: string) => {
    setCurrentItemId((prev) => {
      const newIds = { ...prev };
      delete newIds[id];
      return { ...newIds };
    });
  }, []);

  const isActive = useCallback(
    (id: string) => {
      return currentItemIds[id] !== undefined;
    },
    [currentItemIds]
  );

  return {
    currentItemIds,
    appendId,
    removeId,
    isActive,
  };
};

export const AccordionProvider = (props: AccordionProviderProps) => {
  const { children, multi } = props;
  const value = useAccordionContextProvider(multi);
  return <AccodrionContext.Provider value={value}>{children}</AccodrionContext.Provider>;
};

export const useAccordion = () => useContext(AccodrionContext);
